import React from 'react';
import VBControlEnd from './vbControlEnd';
import { CssInput, CssOptionsContainer } from './vbCssComponents';

class VBDropdown extends React.Component {
    constructor(props){
        super();

        let initial = {value: null, label: null};

        if(props.initial){
            initial = {value: props.initial, label: props.options.find(itm => itm.value == props.initial).label};
        }

        this.state={
            inputValue: initial.label,
            selected: initial,
            error: null,
            hasFocus: false,
            controlEndTrigger: true,
            options: props.options,
            paddingRight: null
        }
        this.controlEnd = React.createRef();
        this.input = React.createRef();
        this.label = React.createRef();
    }

    componentDidMount(){
        //Update the padding on the input to allow any length of suffix
        this.setState({ paddingRight: this.controlEnd.current.getWidth(), labelHeight: this.label.current.clientHeight });
    }

    setValue(value){
        this.setState({ selected: value, inputValue: this.props.options.find(itm => itm.value == value).label })
    }

    onChange(e){
        this.setState({ inputValue: e.target.value });
        this.filterOptions(e.target.value);
    }

    onFocus(){        
        this.setState({hasFocus: true, inputValue:"", options:this.props.options, controlEndTrigger: false})
        
        if(this.props.onFocus){
            this.props.onFocus(this.state.selected);
        }
    }

    onBlur(e){
        let error = ""
        //If validation returns a string its an error message, if null the validation passed
        if(this.props.validation){
            error = this.props.validation(this.state.selected)
        }
        
        let hasFocus = false;
        //Only hide dropdown if focus did not go to an option
        if(e.relatedTarget && e.relatedTarget?.classList){
            if(e.relatedTarget.classList.contains("option")){
                hasFocus = true;
            }
        }
        setTimeout(() => {
            if(document.activeElement){
                hasFocus = document.activeElement.classList.contains("option")
            } 
            
            this.setState({
                error: error,
                inputValue: this.state.selected.label,
                hasFocus: hasFocus
            });
        },1)
        

        // Timeout is for the VBControlEnd to update later otherwise the input focus will trigger again.
        setTimeout(() => { this.setState({ controlEndTrigger: true }) }, 300);

        if(this.props.onBlur){
            this.props.onBlur(this.state.selected);
        }
    }

    onClick(e){
        this.selectElem(e.target);
    }

    setControlEndIcons() {
        if(this.state.hasFocus) {
          return "vb-caret on-focus "+this.props.iconFilter
        } else {
          if (this.props.error) { return " validation-failed"; }
          if (!this.props.validation) { return " vb-caret "+this.props.iconFilter; }
          if (this.state.error) { return " validation-failed"; }
          if (this.state.value != "") { return " validation-ok"; }
          return "vb-caret "+this.props.iconFilter;
        }
    }

    setValidation(){
        //Only show validation styling if the user has left the input and there is something to validate with
        if(this.props.error) { return " validation-failed"; }
        if(!this.props.validation || this.state.hasFocus) { return ""; }
        if(this.state.error) { return " validation-failed"; }
        if(this.state.value != "") { return " validation-ok"; }
        return "";
    }

    handleKeyDown(e){
        if (e.key) {
            if (e.key=="Enter") {
                this.selectElem(e.target);
            } 
            else {
                let new_val = this.state.value + e.key
                this.setState({ value: new_val });
                this.filterOptions(new_val);
                this.input.current.focus();
            }
        }
    }

    selectElem(elem=null, selected=null){
        let error = "";
        if(selected == null){
            selected = { "value": elem.getAttribute('data-value'), "label": elem.innerText };
        }
        
        //If validation returns a string its an error message, if null the validation passed
        if(this.props.validation){
            error = this.props.validation(selected);
        }

        this.setState({
            inputValue: selected.label,
            selected: selected,
            hasFocus: false,
            error: error,
        }, () => {
            if(this.props.onChange){
                this.input.current.blur();
                this.props.onChange(selected);
            }
        })        
    }
        

    filterOptions(val){
        let visible = this.props.options.filter((itm) => itm.label.toLowerCase().startsWith(val.toLowerCase()));

        if(visible.length == 1 && visible[0].label.toLowerCase() == val.toLowerCase()){
            this.selectElem(null, visible[0]);
        } else{
            this.setState({ options: visible });
        }
    }

    render() {
        return (
            <div className="w-100">
                <div ref={this.label} onClick={() => {this.input.current.focus()}}>
                    {this.props.label}
                </div>
                <div className="w-100 d-inline-block position-relative">
                    <CssInput
                        ref={this.input}
                        placeholder={this.props.placeholder} 
                        className={this.props.inputClass+this.setValidation()}
                        style={Object.assign({paddingRight: this.state.paddingRight}, this.props.inputStyle, {usermodify: 'read-only'})}
                        labelHeight={this.state.labelHeight+'px'}
                        onChange={this.onChange.bind(this)}
                        onFocus={this.onFocus.bind(this)}
                        onBlur={this.onBlur.bind(this)}
                        value={this.state.inputValue}
                        disabled={this.props.disabled}
                        required={this.props.required}
                        readOnly={this.props.readOnly}
                        inputMode={this.props.inputMode}
                    />
                    {/* this ads the suffix possibility and the ok/invalid checkbox */}
                    <VBControlEnd 
                        ref={this.controlEnd} 
                        suffix={this.props.suffix} 
                        icon={this.setControlEndIcons()} 
                        onClick={() => {if(this.state.controlEndTrigger){this.input.current.focus()}}}
                        />
                    {this.state.hasFocus ? 
                        <CssOptionsContainer className={`position-absolute overflow-auto ${this.props.optionsContainerClass}`} style={this.props.optionsContainerStyle}>
                            {this.state.options.map((itm) => {    
                                return (
                                <p className="option ps-2 py-xl-3" tabIndex={0} data-value={itm.value} onClick={this.onClick.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}>
                                    {itm.label}
                                </p>
                                );
                            })}
                        </CssOptionsContainer>
                    :null }
                </div>
                <div className="supp-scarlet caption">
                    {this.props.error ? this.props.error : null}
                    {!this.state.hasFocus && !this.props.error ? this.state.error : null}
                </div>
            </div>
            
        );
    }
}

VBDropdown.defaultProps = { inputClass: '',  optionsContainerClass: '', optionsContainerStyle: null, iconFilter: 'primary-dark-filter', inputMode: '', readOnly: false };

export default VBDropdown;